import { FC, useMemo } from 'react'
import * as styles from 'styles/atoms/SvgIcon.styl'
import ReactSvgIcon from 'icons/*.svg'
import cn from 'classnames'

type Size = | 'micro' | 'mini' | 'tiny' | 'small' | 'regular' | 'medium' | 'large'

type SvgIconProps = {
  src: typeof ReactSvgIcon | null
  useDefaultViewBox?: boolean
  className?: string
  size?: Size
}

const SvgIcon: FC<SvgIconProps> = (props) => {
  const {
    src,
    useDefaultViewBox,
    className,
    size,
  } = props

  const iconClassName = useMemo(() => {
    return cn(
      styles.svgIcon,
      className,
      !!size ? styles[size] : undefined
    )
  }, [className, size])

  const Svg = src
  if (!Svg) {
    return null
  }

  // Don't pass `undefined` to `viewBox` it will overrides original value
  const withViewBox: { viewBox?: string } = {}
  if (!useDefaultViewBox) {
    withViewBox.viewBox = '0 0 48 48'
  }

  return (
    <Svg { ...withViewBox } className={ iconClassName } />
  )
}

export default SvgIcon
